import React, { useEffect, useState } from "react";
import { api, s3Url } from "../../service/api.service";
// import { Link } from 'react-router-dom';

export default function UpcomingEvent() {
  const [events, setEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get("/admin/events/all");
        const payload = response?.data || response?.events || response || [];
        const allEvents = Array.isArray(payload)
          ? payload
          : payload?.data || [];
        setEvents(allEvents);

        // filter events to show only those with end date >= today (current date to future)
        const now = new Date();
        const filtered = allEvents.filter((ev) => {
          const endDate =
            ev?.effectiveEnd ||
            ev?.endDate ||
            ev?.eventEnd ||
            ev?.eventDate ||
            ev?.end;
          if (!endDate) return false; // skip events without an end date
          try {
            return new Date(endDate) >= now;
          } catch (e) {
            return false;
          }
        });
        setUpcomingEvents(filtered);
      } catch (err) {
        console.error("Upcoming events API error:", err);
        setError("Unable to load upcoming events.");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const getImageUrl = (event) => {
    const source =
      event?.imageUrl ||
      event?.bannerImage ||
      event?.thumbnail ||
      event?.poster ||
      event?.image;
    if (!source) return "/assets/media-3.png";
    return source.startsWith("http") ? source : `${s3Url}${source}`;
  };

  const getTitle = (event) => {
    return (
      event?.title ||
      event?.name ||
      event?.eventName ||
      event?.eventTitle ||
      "Upcoming Event"
    );
  };

  const getDescription = (event) => {
    return (
      event?.description ||
      event?.details ||
      event?.about ||
      "Stay tuned for event details and updates."
    );
  };

  const getImageList = (event) => {
    const list =
      event?.images ||
      event?.imageUrls ||
      event?.fileUrls ||
      event?.gallery ||
      event?.imagesList ||
      (event?.image ? [event.image] : null) ||
      (event?.thumbnail ? [event.thumbnail] : null);

    if (!list) return [];
    if (!Array.isArray(list))
      return [list.startsWith("http") ? list : `${s3Url}${list}`];
    return list
      .filter(Boolean)
      .map((src) => (src.startsWith("http") ? src : `${s3Url}${src}`));
  };

  // no slider: render events in a responsive grid; each event shows its images

  return (
    <>
      <div className="py-20 relative">
        <div className="bg-[#FFF5F3]">
          <image src="./assets/shapeline.png" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto">
          <div
            className="flex items-center justify-center gap-7 mb-8"
            style={{ fontFamily: "Philosopher, sans-serif" }}
          >
            <h2 className="text-6xl">
              Upcoming <span className="text-primary mb-9">Events</span>
            </h2>
          </div>

          {loading ? (
            <div className="text-center text-lg text-gray-500">
              Loading events...
            </div>
          ) : error ? (
            <div className="text-center text-red-600">{error}</div>
          ) : upcomingEvents.length === 0 ? (
            <div className="text-center text-gray-500">
              No upcoming events found.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4">
              {upcomingEvents.map((event, index) => {
                const images = getImageList(event);
                return (
                  <div
                    key={`event-${index}-${getTitle(event)}`}
                    className="p-4"
                  >
                    <div className="bg-white p-3 rounded-2xl overflow-hidden shadow-md w-full h-fit">
                      <div className="mb-3">
                        {images.length > 0 ? (
                          <div className="grid grid-cols-3 gap-2">
                            {images.slice(0, 6).map((imgSrc, i) => (
                              <img
                                key={`evt-${index}-img-${i}`}
                                src={imgSrc}
                                alt={`${getTitle(event)}-${i}`}
                                className="w-full h-20 object-cover rounded"
                              />
                            ))}
                            {images.length > 6 && (
                              <div className="col-span-3 text-center text-sm text-gray-500 mt-2">
                                +{images.length - 6} more
                              </div>
                            )}
                          </div>
                        ) : (
                          <img
                            src={getImageUrl(event)}
                            alt={getTitle(event)}
                            className="w-full h-fit object-cover rounded"
                          />
                        )}
                      </div>
                      <h3 className="text-lg font-semibold text-gray-800 truncate">
                        {getTitle(event)}
                      </h3>
                      {event?.effectiveStart ||
                      event?.effectiveEnd ||
                      event?.startDate ||
                      event?.endDate ? (
                        <div className="text-sm text-gray-500 mt-1">
                          {(() => {
                            const startText = formatDate(
                              event?.effectiveStart ||
                                event?.startDate ||
                                event?.date
                            );
                            const endText = formatDate(
                              event?.effectiveEnd ||
                                event?.endDate ||
                                event?.eventDate ||
                                event?.date
                            );
                            return startText === endText
                              ? startText
                              : `${startText} To ${endText}`;
                          })()}
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
